import { buildCacheClient } from '../../../common/api/cacheClientBuilder';
import { queryClient } from './queryClient';

const { CACHE_ACTIONS, updateCacheArray } = buildCacheClient({ queryClient });

export { CACHE_ACTIONS, updateCacheArray };
